var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCirleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.077C0 4.959 4.96 0 11.077 0c6.118 0 11.077 4.96 11.077 11.077 0 6.118-4.96 11.077-11.077 11.077C4.959 22.154 0 17.194 0 11.077z",
    fill: "url(#checkCir\\u0441leIcon_svg__paint0_linear_45214_6075)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.461 11.077l3.044 3.692 6.188-7.384",
    stroke: "#1A1B24",
    strokeWidth: 1.846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "checkCir\\u0441leIcon_svg__paint0_linear_45214_6075",
    x1: 0,
    y1: 11.286,
    x2: 22.154,
    y2: 11.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85C400"
  })))));
}

export default SvgCheckCirleIcon;